module.exports = __webpack_public_path__ + "img/lg_ring_r_s_1_0.41964060.png";